module.exports = __webpack_public_path__ + "img/icon.17fc2cdc.jpg";